import { get, post } from '../core/http';

export interface HomePageQuery {
  current?: number;
  size?: number;
  total?: number;
}

export interface HomePageResult<T> {
  current?: number;
  data?: T[];
  pages?: number;
  size?: number;
  total?: number;
}

export interface HomeBannerItem {
  actionType?: number;
  cover?: string;
  createTime?: number;
  createUser?: number;
  description?: string;
  id?: number;
  ifVideo?: boolean;
  link?: string;
  newCover?: string;
  newVideoUrl?: string;
  page?: number;
  releaseDate?: number;
  sort?: number;
  status?: number;
  title?: string;
  type?: string;
  updateTime?: number;
  updateUser?: number;
  videoId?: number;
  videoUrl?: string;
}

export interface HomeBannerListParams {
  page?: number;
  status: number;
  type: string;
}

export interface HomeNewsItem {
  actionType?: number;
  content?: string;
  createTime?: number;
  createUser?: number;
  id?: number;
  ifEvent?: boolean;
  images?: string[];
  links?: string[];
  newImages?: string[];
  newsDescription?: string;
  newsDisplayTime?: number;
  newsReleaseTime?: number;
  newsShowType?: number;
  newsTitle?: string;
  newsViewCount?: number;
  pdfs?: string[];
  status?: number;
  updateTime?: number;
  updateUser?: number;
}

export interface HomeNewsPageParams {
  ifEvent?: boolean;
  ifShow?: boolean;
  newsDescription?: string;
  newsTitle?: string;
  pageId?: number;
  pageVo?: HomePageQuery;
  sortByPopularity?: string;
  sortByReleaseTime?: string;
  status?: number;
}

export interface HomeNewsViewCountParams {
  id: number;
  pageId: number;
}

export interface HomeActionBrowseParams {
  browseTime?: string;
  buttonId?: number;
  dept?: string;
  entity?: string;
  id?: number;
  mail?: string;
  pageId?: number;
  type?: number;
  uid?: string;
  userId?: number;
}

export const homeApi = {
  getBannerList(params: HomeBannerListParams) {
    return get<HomeBannerItem[], HomeBannerListParams>('/home/front/banner/list', params);
  },

  getNewsFrontPage(params: HomeNewsPageParams) {
    return post<HomePageResult<HomeNewsItem>, HomeNewsPageParams>('/news/front/page', params);
  },

  viewNewsCount(params: HomeNewsViewCountParams) {
    return get<string, HomeNewsViewCountParams>('/news/front/viewCount', params);
  },

  recordActionBrowse(params: HomeActionBrowseParams) {
    return post<string, HomeActionBrowseParams>('/dashboard/front/recordAB', params);
  },

  getGuideMark() {
    return get<boolean>('/login/guideMark');
  },
};
